import { create } from 'zustand';
import { OrdemServico, FamilyAccess, RealTimeUpdate } from '../types';
import api from '../utils/api';

interface FamilyStore {
  // Estado
  codigoAcesso: string;
  ordemServico: OrdemServico | null;
  isLoading: boolean;
  error: string | null;
  isAuthenticated: boolean;
  realTimeUpdates: RealTimeUpdate[];
  
  // Actions
  setCodigoAcesso: (codigo: string) => void;
  buscarOSPorCodigo: (codigo: string) => Promise<boolean>;
  limparOS: () => void;
  adicionarUpdate: (update: RealTimeUpdate) => void;
  limparUpdates: () => void;
  clearError: () => void;
}

export const useFamilyStore = create<FamilyStore>((set, get) => ({
  // Estado inicial
  codigoAcesso: '',
  ordemServico: null,
  isLoading: false,
  error: null,
  isAuthenticated: false,
  realTimeUpdates: [],

  // Definir código de acesso
  setCodigoAcesso: (codigo: string) => {
    set({ codigoAcesso: codigo });
  },

  // Buscar OS por código de acesso
  buscarOSPorCodigo: async (codigo: string): Promise<boolean> => {
    set({ isLoading: true, error: null });
    
    try {
      console.log('🔍 Buscando OS com código:', codigo);
      
      // Buscar OS por código de acesso
      const response = await api.get(`/os/public/${codigo}`);
      
      if (response.data.os) {
        const os = response.data.os;
        console.log('✅ OS encontrada:', os);
        
        set({
          ordemServico: os,
          isAuthenticated: true,
          isLoading: false,
          error: null
        });
        
        return true;
      } else {
        set({
          error: 'Código de acesso inválido ou OS não encontrada',
          isLoading: false,
          isAuthenticated: false
        });
        return false;
      }
      
    } catch (error: any) {
      console.error('❌ Erro ao buscar OS:', error);
      
      let errorMessage = 'Erro ao buscar OS';
      
      if (error.response?.status === 404) {
        errorMessage = 'Código de acesso não encontrado';
      } else if (error.response?.status === 400) {
        errorMessage = 'Código de acesso inválido';
      } else if (error.response?.data?.error) {
        errorMessage = error.response.data.error;
      }
      
      set({
        error: errorMessage,
        isLoading: false,
        isAuthenticated: false
      });
      
      return false;
    }
  },

  // Limpar OS atual
  limparOS: () => {
    set({
      ordemServico: null,
      isAuthenticated: false,
      codigoAcesso: '',
      realTimeUpdates: []
    });
  },

  // Adicionar atualização em tempo real
  adicionarUpdate: (update: RealTimeUpdate) => {
    set((state) => ({
      realTimeUpdates: [...state.realTimeUpdates, update]
    }));
    
    // Manter apenas as últimas 50 atualizações
    const { realTimeUpdates } = get();
    if (realTimeUpdates.length > 50) {
      set({
        realTimeUpdates: realTimeUpdates.slice(-50)
      });
    }
  },

  // Limpar atualizações
  limparUpdates: () => {
    set({ realTimeUpdates: [] });
  },

  // Limpar erro
  clearError: () => {
    set({ error: null });
  },
}));
